import axios from "axios";

import config from "../config/env";

export const getProjectViews = (project_reference: string) =>
  axios.get(`${config.API}/views?project_reference=${project_reference}`);
